<div class="np-mdi d-flex flex-column h-100" (window:resize)="updateOverflow()">

    <!-- 탭 바 -->
    <div class="np-mdi-tabbar d-flex align-items-end">

        <!-- Home(np-mdi-home이 있을 때만): 스크롤 영역 밖에 고정, 닫기 없음. 아이콘 + 타이틀, 타이틀이 없으면 아이콘만 -->
        @if (home) {
        <div class="np-mdi-tab np-mdi-tab-home d-flex align-items-center justify-content-center gap-2 px-3"
            [class.is-active]="mdi.activeId === null" (click)="activateHome()" (contextmenu)="openTabMenu($event, null)">
            <i class="fa-solid {{ home.icon }} fa-fw"></i>
            @if (home.title) {
            <span class="text-nowrap">{{ home.title }}</span>
            }
        </div>
        }

        @if (tabOverflow) {
        <button type="button" class="btn btn-sm np-mdi-tabbar-btn" title="왼쪽으로" (click)="scrollTabs(-1)">
            <i class="fa-solid fa-chevron-left"></i></button>
        }
        <div #tabBar class="np-mdi-tabs d-flex flex-grow-1" (wheel)="onTabBarWheel($event)" (scroll)="updateOverflow()">
            @for (t of mdi.tabs; track t.id) {
            <div class="np-mdi-tab d-flex align-items-center gap-2 px-2" [class.is-active]="t.id === mdi.activeId"
                [title]="t.title" (click)="activate(t.id)" (auxclick)="onTabAuxClick($event, t.id)"
                (contextmenu)="openTabMenu($event, t.id)">
                <i class="fa-solid {{ t.icon }} fa-fw np-mdi-tab-icon"></i>
                <span class="flex-grow-1 text-truncate">{{ t.title }}</span>
                @if (isDirty(t.id)) {
                <span class="np-mdi-tab-dirty" title="저장하지 않은 수정 내용이 있습니다."></span>
                }
                <button type="button" class="btn btn-sm p-0 np-mdi-tab-close" title="닫기" (click)="dismiss(t.id, $event)">
                    <i class="fa-solid fa-xmark"></i></button>
            </div>
            }
        </div>
        @if (tabOverflow) {
        <button type="button" class="btn btn-sm np-mdi-tabbar-btn" title="오른쪽으로" (click)="scrollTabs(1)">
            <i class="fa-solid fa-chevron-right"></i></button>
        }

        <!-- 열린 창 목록 -->
        <div class="position-relative">
            <button type="button" class="btn btn-sm np-mdi-tabbar-btn d-flex align-items-center gap-1 text-nowrap"
                title="열린 창 목록" (click)="tabListOpen = !tabListOpen">
                <i class="fa-solid fa-layer-group"></i>
                <span class="small">{{ mdi.tabs.length }}</span>
            </button>
            @if (tabListOpen) {
            <!-- 헤더와 하단 버튼은 고정, 창 목록만 스크롤 -->
            <div class="dropdown-menu dropdown-menu-end show shadow-sm d-flex flex-column py-0 np-mdi-tablist">
                <div class="dropdown-header border-bottom py-2">열린 창 {{ mdi.tabs.length }}개</div>
                <div class="np-mdi-tablist-items py-1">
                    @if (home) {
                    <button type="button" class="dropdown-item d-flex align-items-center gap-2"
                        [class.active]="mdi.activeId === null" (click)="activateHome()">
                        <i class="fa-solid {{ home.icon }} fa-fw"></i>
                        <span class="text-truncate">{{ home.title || 'Home' }}</span>
                    </button>
                    }
                    @for (t of mdi.tabs; track t.id) {
                    <div class="d-flex align-items-center">
                        <button type="button" class="dropdown-item d-flex align-items-center gap-2"
                            [class.active]="t.id === mdi.activeId" (click)="activate(t.id)">
                            <i class="fa-solid {{ t.icon }} fa-fw"></i>
                            <span class="text-truncate">{{ t.title }}</span>
                        </button>
                        <button type="button" class="btn btn-sm text-muted" title="닫기" (click)="dismiss(t.id, $event)">
                            <i class="fa-solid fa-xmark"></i></button>
                    </div>
                    }
                </div>
                <div class="border-top py-1">
                    <button type="button" class="dropdown-item" (click)="dismissOthers()">다른 탭 모두 닫기</button>
                    <button type="button" class="dropdown-item text-danger" (click)="dismissAll()">모두 닫기</button>
                </div>
            </div>
            }
        </div>
    </div>

    <!-- 탭 우클릭 메뉴: 누른 위치에 띄운다. Home에서 열면 '닫기'는 없다 -->
    @if (tabMenu) {
    <div class="dropdown-menu show shadow-sm py-1 np-mdi-tab-menu" [style.left.px]="tabMenu.x" [style.top.px]="tabMenu.y"
        (click)="$event.stopPropagation()" (contextmenu)="$event.preventDefault(); $event.stopPropagation()">
        @if (tabMenu.tabId !== null) {
        <button type="button" class="dropdown-item" (click)="menuDismiss(tabMenu.tabId)">닫기</button>
        }
        <button type="button" class="dropdown-item" [disabled]="mdi.tabs.length <= (tabMenu.tabId === null ? 0 : 1)"
            (click)="menuDismissOthers(tabMenu.tabId)">다른 탭 닫기</button>
        <button type="button" class="dropdown-item" [disabled]="!hasRightTabs(tabMenu.tabId)"
            (click)="menuDismissRight(tabMenu.tabId)">오른쪽 탭 닫기</button>
        <div class="dropdown-divider my-1"></div>
        <button type="button" class="dropdown-item text-danger" [disabled]="mdi.tabs.length === 0"
            (click)="menuDismissAll()">모두 닫기</button>
    </div>
    }

    <div class="flex-grow-1 overflow-auto np-mdi-content">
        <!-- Home: np-mdi-home의 내용. 다른 탭이 활성화되면 숨긴다. np-mdi-home이 없으면 Home이 없는 MDI -->
        <div class="h-100 p-3" [hidden]="!home || mdi.activeId !== null">
            <ng-content select="np-mdi-home" />
        </div>

        <!-- 탭 화면: 비활성 탭은 [hidden] + 변경 감지 분리. 화면이 닫기를 요청하면 탭을 닫는다. -->
        @for (t of mdi.tabs; track t.id) {
        <div class="h-100 p-3" [hidden]="t.id !== mdi.activeId">
            <ng-container [npMdiTabOutlet]="t.component" [npMdiTabOutletInputs]="t.inputs" [npMdiTabOutletTabId]="t.id"
                [npMdiTabOutletActive]="t.id === mdi.activeId" (npMdiTabOutletClose)="mdi.close(t.id)"
                (npMdiTabOutletDismiss)="mdi.dismiss(t.id)" />
        </div>
        }
    </div>

</div>
